// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import OutcomesBonus from './OutcomesBonus.container';

export default OutcomesBonus;
